import {
  WappActivityCreateEntityPayload,
  WappActivityEntity,
  WappActivityPostPayload,
  WappActivitySearchPayload,
} from '@weblite-wapps/protocol'
import { getWapp } from '$logic/wapps/service'
import { deleteRequest, postRequest, putRequest } from './api'

export async function postActivity(activity: WappActivityPostPayload) {
  const res = await postRequest<string>('/activity', activity)
  return res.data
}

export async function searchEntities(query: WappActivitySearchPayload) {
  const res = await postRequest<WappActivityEntity[]>('/search', query)
  return res.data
}

export async function createEntity(
  entity: WappActivityCreateEntityPayload,
  wappId: string,
) {
  const wapp = await getWapp(wappId)
  const res = await postRequest<{ contentUri: string }>('/entity', {
    ...entity,
    tenant: wapp.groupName,
  })
  return res.data
}

export async function editEntity(
  entity: WappActivityCreateEntityPayload,
  wappId: string,
) {
  const wapp = await getWapp(wappId)
  const res = await putRequest<string>('/entity', {
    ...entity,
    tenant: wapp.groupName,
  })
  return res.data
}

export async function deleteEntity(instanceId: string, tenant: string) {
  const res = await deleteRequest<string>('/entity', { instanceId, tenant })
  return res.data
}

export const decodeContentUri = (contentUri: string) => {
  return {
    instanceId: contentUri.split('/')[3],
    tenant: contentUri.split('/')[2],
  }
}

export const encodeContentUri = (tenant: string, instanceId: string) =>
  `wappactivity://${tenant}/${instanceId}`
